module.exports = __webpack_public_path__ + "assets/logo-horizontal-white.8f00f9fa.svg";